(($) => {
  $(document).ready(() => {
    $('#page-home ul.depoimentos').slick({
      slidesToShow: 2,
      prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    })
  })
})(jQuery)
